import { render, staticRenderFns } from "./DossierWorkSchedule.vue?vue&type=template&id=4fa62514&"
import script from "./DossierWorkSchedule.vue?vue&type=script&lang=js&"
export * from "./DossierWorkSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports